//React
import { useState, useCallback, useEffect } from 'react';
import { Form, Image } from 'react-bootstrap';
import ReactSecureStorage from 'react-secure-storage';
//API
import { LoginApi } from './apis';
//Material-UI
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
//Components
import aidlogo from '../src/asset/LOGO.svg';
import MyCircularProgress from '../src/components/Circleprogess';
import BasicModal from '../src/components/Modal';
import ChangePassword from './components/ChangePassword';

const inputStyle = {
  width: '100%',
  height: '45px',
  border: 'none',
  borderTop: '0.5px solid rgba(0, 0, 0, 0.20)',
  borderRight: '2px solid rgba(0, 0, 0, 0.20)',
  borderBottom: '2px solid rgba(0, 0, 0, 0.20)',
  borderLeft: '0.5px solid rgba(0, 0, 0, 0.20)',
  background: '#FFF',
  borderRadius: '5px',
  fontWeight: '400',
  padding: '0px 15px',
};

const LoginForm = ({ setAuthenticated, history }) => {
  const [id, setId] = useState(ReactSecureStorage.getItem('email') || '');
  const [password, setPassword] = useState('');
  const [capsLock, setCapsLock] = useState(false);
  const [passwordShown, setPasswordShown] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalContent, setModalContent] = useState('');
  const [firstLoginModalStatus, setFirstLoginModalStatus] = useState(false);

  const params = new URLSearchParams(window.location.search);
  const redirectPath = params.get("redirect") || "/home";

  const [isReloaded, setIsReloaded] = useState(false);

  useEffect(() => {
    if (performance.navigation.type === 0 && !isReloaded) {
      setIsReloaded(true);
      window.location.reload();
    }
  }, [isReloaded]);

  const togglePasswordVisibility = useCallback(() => {
    setPasswordShown((prevState) => !prevState);
  }, []);

  const handleClick = useCallback(async () => {
    setLoading(true);
    if (!id) {
      showModalWithContent('Please enter a valid email address.');
      setLoading(false);
      return;
    }
    try {
      const response = await LoginApi.login(id, password);
      const { statusCode, message } = response;

      if (statusCode === 200) {
        if (response.data.member.memberStatus !== 'ACCEPTED') {
          setLoading(false);
          setFirstLoginModalStatus(true);
          setPassword('');
        } else {
          setAuthenticated(true);
          //history.push('/home');
          if (ReactSecureStorage.getItem('redirect') === 'undefined' || 
            ReactSecureStorage.getItem('redirect') === null) {
            history.push('/home');
          } else {
            history.push(redirectPath);
          }
        }
      } else {
        showModalWithContent(`${message}`);
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  }, [id, password, setAuthenticated, history]);

  const handleKeyUp = useCallback((event) => {
    setCapsLock(event.getModifierState('CapsLock'));
  }, []);

  const handleKeyDown = useCallback(
    (event) => {
      if (event.keyCode === 13) handleClick();
    },
    [handleClick],
  );

  const handleModalClose = useCallback(() => setModalStatus(false), []);

  const handleFirstLoginModalClose = useCallback(
    () => setFirstLoginModalStatus(false),
    [],
  );

  const showModalWithContent = useCallback((content) => {
    setModalContent(content);
    setModalStatus(true);
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <style>{`
        textarea:focus, input:focus {
          outline: none;
        }
      `}</style>

      <div
        style={{
          width: '460px',
          background: '#FFF',
          boxShadow: '3px 3px 10px 3px #CECECE',
          padding: '45px',
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              boxSizing: 'border-box',
            }}
          >
            <div style={{ display: 'flex' }}>
              <Image
                src={aidlogo}
                style={{ marginRight: '5px', width: '30px' }}
              />
              <div
                style={{
                  fontWeight: '600',
                  color: '#000',
                  fontSize: '1.25rem',
                }}
              >
                AiD Regen
              </div>
            </div>
            <div variant="h5" style={{ fontWeight: '600', margin: '25px 0' }}>
              LOGIN
            </div>
            <Form.Group style={{ marginBottom: '15px' }}>
              <Form.Label style={{ marginBottom: '5px', paddingLeft: '5px' }}>
                Email
              </Form.Label>
              <input
                onChange={(e) => setId(e.target.value)}
                style={inputStyle}
                type="text"
                value={id}
                placeholder="Email"
                maxLength={100}
              />
            </Form.Group>
            <Form.Group style={{ marginBottom: '0px' }}>
              <Form.Label style={{ marginBottom: '5px', paddingLeft: '5px' }}>
                Password
              </Form.Label>
              <div style={{ position: 'relative' }}>
                <input
                  onKeyUp={handleKeyUp}
                  onKeyDown={handleKeyDown}
                  type={passwordShown ? 'text' : 'password'}
                  value={password}
                  placeholder="Password"
                  onChange={(e) => setPassword(e.target.value)}
                  style={inputStyle}
                />
                <button
                  onClick={togglePasswordVisibility}
                  style={{
                    position: 'absolute',
                    right: 10,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    background: 'none',
                    border: 'none',
                  }}
                >
                  {passwordShown ? <VisibilityOffIcon /> : <VisibilityIcon />}
                </button>
              </div>
            </Form.Group>

            <div style={{ textAlign: 'right' }}>
              <a
                href="/distributorRequest"
                onClick={(e) => {
                  history.push('/distributorRequest');
                }}
                style={{
                  textDecoration: 'underline', 
                  color: '#0077cc', 
                  cursor: 'pointer',
                  fontSize: 'inherit',
                }}
              >
                Distributor Account Request
              </a>
            </div>

            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                height: '20px',
                paddingLeft: '5px',
              }}
            >
              {capsLock ? (
                <>
                  <InfoOutlinedIcon style={{ fontSize: '1.125rem' }} />
                  <div style={{ paddingLeft: '3px', color: '#495057' }}>
                    Caps Lock is On
                  </div>
                </>
              ) : null}
            </div>
            <button
              onClick={handleClick}
              style={{
                backgroundColor: 'rgb(63, 89, 140)',
                color: '#FFF',
                height: '50px',
                fontSize: '16px',
                fontWeight: '500',
                textTransform: 'none',
                width: '100%',
                borderRadius: '10px',
                marginTop: '30px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              {!loading ? (
                'Login'
              ) : (
                <MyCircularProgress color="white" thickness={4} size={30} />
              )}
            </button>
          </div>
        </div>
        <div style={{ display: 'none' }}>
          <BasicModal
            open={modalStatus}
            handleModalClose={handleModalClose}
            content={modalContent}
          />
          <ChangePassword
            email={id}
            open={firstLoginModalStatus}
            handleModalClose={handleFirstLoginModalClose}
          />
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
